<template>
  <div class="form-check">
    <input
      @input="(event) => $emit('update:checked', event.target.checked)"
      type="checkbox"
      :checked="checked"
      :id="id"
      :name="name"
      class="form-check-input"
    />
    <label :for="id" class="form-check-label">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    id: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
    },
  },
};
</script>
